import { useBackendSync } from "@/hooks/useBackendData";

export const BackendSyncBridge = (): null => {
  useBackendSync();
  return null;
};
